module.exports = __webpack_public_path__ + "static/media/wedding-2.679b5b7f.mp4";